import moment from 'moment';
require('dotenv').config();

const { BlobServiceClient } = require("@azure/storage-blob");
import states from './states';

const account = "acgdprspecialeventfiles";
const sas = "?sv=2020-08-04&ss=b&srt=o&sp=c&se=2031-09-17T01:34:32Z&st=2021-09-16T17:34:32Z&spr=https,http&sig=JeBvXTnzCSspeGT4zeHPV0CcIEltEfnpTeAhqZbVkqM%3D";

const blobServiceClient = new BlobServiceClient(
  `https://${account}.blob.core.windows.net?${sas}`
);

const containerName = "attachments";

const saveDraftHttpFunction = 'https://dpr-specialeventappsaves-azfunction.azurewebsites.net/api/Save?code=GqH3FKBEa1q1aTqgR4br0k/xSdJsR5rssnbuKKytc5YiuPImyPfP0A==';
//const saveDraftHttpFunction = "http://localhost:7071/api/Save?foo=biz";
const service = {

  states() { return states },

  createPackage(data) {
    let setupTime = data.SEA_SetupTime ? moment(data.SEA_SetupTime).format("YYYY-MM-DDTHH:mm:ss") : null; // .tz("America/New_York").format() //  + "Z"
    let eventStartTime = data.SEA_EventStartTime ? moment(data.SEA_EventStartTime).format("YYYY-MM-DDTHH:mm:ss") : null;
    let eventEndTime = data.SEA_EventEndTime ? moment(data.SEA_EventEndTime).format("YYYY-MM-DDTHH:mm:ss") : null;
    let breakdownTime = data.SEA_BreakdownTime ? moment(data.SEA_BreakdownTime).format("YYYY-MM-DDTHH:mm:ss") : null;
    let packEvents = []
    if (data.events) {
      if (data.events.length > 0) {

        for (let index = 0; index < data.events.length; index++) {
          const element = data.events[index];
          let newEvent = {
            SEA_SetupTime: { selectedDate: element.SEA_SetupTime ? moment(element.SEA_SetupTime).format("YYYY-MM-DDTHH:mm:ss") : null }, // .tz("America/New_York").format() //  + "Z"
            SEA_EventStartTime: { selectedDate: element.SEA_EventStartTime ? moment(element.SEA_EventStartTime).format("YYYY-MM-DDTHH:mm:ss") : null },
            SEA_EventEndTime: { selectedDate: element.SEA_EventEndTime ? moment(element.SEA_EventEndTime).format("YYYY-MM-DDTHH:mm:ss") : null },
            SEA_BreakdownTime: { selectedDate: element.SEA_BreakdownTime ? moment(element.SEA_BreakdownTime).format("YYYY-MM-DDTHH:mm:ss") : null },
          }
          packEvents.push(newEvent)
        }
      }
    }
    let topics = "";
    //console.log(data.SEA_Topics);
    if (data.SEA_Topics) {
      if (data.SEA_Topics.length > 0) {
        for (let index = 0; index < data.SEA_Topics.length; index++) {
          const element = data.SEA_Topics[index];
          if (index === 0) {
            topics = element;
          } else {
            topics = topics + "," + element;
          }
        }
      }
    }
    let SEA_DIS_List = []
    if (data.SEA_DIS_List) {
      if (data.SEA_DIS_List.length > 0) {

        for (let index = 0; index < data.SEA_DIS_List.length; index++) {
          const element = data.SEA_DIS_List[index];
          let newEvent = {
            dis_type: {value: element.dis_type},
            dis_StartTime: { selectedDate: element.dis_StartTime ? moment(element.dis_StartTime).format("YYYY-MM-DDTHH:mm:ss") : null }, // .tz("America/New_York").format() //  + "Z"
            dis_EndTime: { selectedDate: element.dis_EndTime ? moment(element.dis_EndTime).format("YYYY-MM-DDTHH:mm:ss") : null },
            dis_Location: {value: element.dis_Location},
            dis_Extent: {value: element.dis_Extent},
          }
          SEA_DIS_List.push(newEvent)
        }
      }
    }
    return {
      id: data.id,
      SendFields: {
        SEA_Title: { value: data.SEA_Title },
        SEA_Location: { value: data.SEA_Location },
        SEA_CivicAssociation: { selectedValue: data.SEA_CivicAssociation },
        SEA_Summary: { value: data.SEA_Summary },
        SEA_Vision: { value: data.SEA_Vision },
        SEA_PreviouslyHeld: { selectedValue: data.SEA_PreviouslyHeld },
        SEA_PreviousDate: { selectedDate: data.SEA_PreviousDate },
        SEA_PreviousSponsor: { value: data.SEA_PreviousSponsor },
        SEA_PreviousLocation: { value: data.SEA_PreviousLocation },
        SEA_IsThisaSingle: { selectedValue: data.SEA_IsThisaSingle },
        SEA_SetupTime: { selectedDate: setupTime },
        SEA_EventStartTime: { selectedDate: eventStartTime },
        SEA_EventEndTime: { selectedDate: eventEndTime },
        SEA_BreakdownTime: { selectedDate: breakdownTime },
        SEA_AttendeesMin: { value: data.SEA_AttendeesMin },
        SEA_AttendeesMax: { value: data.SEA_AttendeesMax },
        SEA_ManagerNameFirst: { value: data.SEA_ManagerNameFirst },
        SEA_ManagerNameLast: { value: data.SEA_ManagerNameLast },
        SEA_ManagerEmail: { value: data.SEA_ManagerEmail },
        SEA_EventContactPhone: { value: data.SEA_EventContactPhone },
        SEA_Nonprofit: { selectedValue: data.SEA_Nonprofit },
        SEA_SponsorNameFirst: { value: data.SEA_SponsorNameFirst },
        SEA_SponsorNameLast: { value: data.SEA_SponsorNameLast },
        SEA_SponsorEmail: { value: data.SEA_SponsorEmail },
        SEA_SponsorContactPhone: { value: data.SEA_SponsorContactPhone },
        SEA_SponsorAddress1: { value: data.SEA_SponsorAddress1 },
        SEA_SponsorAddress2: { value: data.SEA_SponsorAddress2 },
        SEA_SponsorAddressCity: { value: data.SEA_SponsorAddressCity },
        SEA_SponsorAddressState: { value: data.SEA_SponsorAddressState },
        SEA_SponsorAddressZIP: { value: data.SEA_SponsorAddressZIP },
        SEA_PreviousGrossRevenue: { value: data.SEA_PreviousGrossRevenue },
        SEA_PreviousCost: { value: data.SEA_PreviousCost },
        SEA_PreviousCharges: { value: data.SEA_PreviousCharges },
        SEA_EstimatedGrossRevenue: { value: data.SEA_EstimatedGrossRevenue },
        SEA_EstimatedTotalExpense: { value: data.SEA_EstimatedTotalExpense },
        SEA_FeeReductionAward: { selectedValue: data.SEA_FeeReductionAward === 'Yes' ? 1 : 0 },
        SEA_PSS_Extreme: { selectedValue: data.SEA_PSS_Extreme },
        SEA_PSS_StreetClosures: { selectedValue: data.SEA_PSS_StreetClosures },
        SEA_PSS_ClosureArea: { selectedValue: data.SEA_PSS_ClosureArea },
        SEA_PSS_ClosureAreaDesc: { value: data.SEA_PSS_ClosureAreaDesc },
        SEA_PSS_Checkpoints: { selectedValue: data.SEA_PSS_Checkpoints },
        SEA_PSS_Hazardous: { selectedValue: data.SEA_PSS_Hazardous },
        SEA_PSS_HazardousPurpose: { value: data.SEA_PSS_HazardousPurpose },
        SEA_PSS_KnownThreats: { selectedValue: data.SEA_PSS_KnownThreats },
        SEA_PSS_SecurityStaff: { value: data.SEA_PSS_SecurityStaff },
        SEA_PSS_Sound: { selectedValue: data.SEA_PSS_Sound },
        SEA_PSS_SoundDesc: { value: data.SEA_PSS_SoundDesc },
        SEA_PSS_Overnight: { selectedValue: data.SEA_PSS_Overnight },
        SEA_PSS_Assemblage: { selectedValue: data.SEA_PSS_Assemblage },
        SEA_Certificate_ANIRequired_1: { value: data.SEA_Certificate_ANIRequired_1 === 'Yes' ? 1 : 0 },
        SEA_Animals: { selectedValue: data.SEA_Animals },
        SEA_Certificate_INSRequired_2: { value: data.SEA_Certificate_INSRequired_2 === 'Yes' ? 1 : 0 },
        SEA_Insurance: { selectedValue: data.SEA_Insurance },
        SEA_InsuranceName: { value: data.SEA_InsuranceName },
        SEA_License: { value: data.SEA_License === 'Yes' ? 1 : 0 },
        SEA_Public: { value: data.SEA_Public },
        SEA_Publicized: { value: data.SEA_Publicized === 'Yes' ? 1 : 0 },
        SEA_CalendarDescription: { value: data.SEA_CalendarDescription },
        SEA_FreeOrPaid: { selectedValue: data.SEA_FreeOrPaid },
        SEA_EventFee: { value: data.SEA_EventFee },
        SEA_Topics: { selectedValue: topics },
        SEA_IsThisaFamilyFriendly: { selectedValue: data.SEA_IsThisaFamilyFriendly === 'Yes' ? 1 : 0 },
        SEA_MinimumAge: { value: data.SEA_MinimumAge },
        SEA_MaximumAge: { value: data.SEA_MaximumAge },
        SEA_PublicContactNameFirst: { value: data.SEA_PublicContactNameFirst },
        SEA_PublicContactNameLast: { value: data.SEA_PublicContactNameLast },
        SEA_PublicContactEmail: { value: data.SEA_PublicContactEmail },
        SEA_PublicContactPhone: { value: data.SEA_PublicContactPhone },
        SEA_Website: { value: data.SEA_Website },
        SEA_MobileStage: { value: data.SEA_MobileStage },
        SEA_PlanUpload: { value: data.SEA_PlanUpload },
        SEA_PlanURL: { value: data.SEA_PlanURL },
        SEA_Tents: { value: data.SEA_Tents },
        SEA_Permit_OCCRequired_5: { value: data.SEA_Permit_OCCRequired_5 }, //  === 'Yes' ? 1 : 0
        SEA_Permit_BUILDRequired_6: { value: data.SEA_Permit_BUILDRequired_6 }, //  === 'Yes' ? 1 : 0
        SEA_AmusementDevices: { value: data.SEA_AmusementDevices },
        SEA_AmusementDeviceDesc: { value: data.SEA_AmusementDeviceDesc },
        SEA_Permit_ElectricalRequired_11: { value: data.SEA_Permit_ElectricalRequired_11 }, //  === 'Yes' ? 1 : 0
        SEA_Permit_ElectricalNotes_11: { value: data.SEA_Permit_ElectricalNotes_11 },
        SEA_WaterStation: { value: data.SEA_WaterStation },
        SEA_StreetSweeping: { selectedValue: data.SEA_StreetSweeping },
        SEA_WasteDisposalPlan: { value: data.SEA_WasteDisposalPlan },
        SEA_WasteTypeQual: { value: data.SEA_WasteTypeQual },
        SEA_WasteCompostableMaterials: { value: data.SEA_WasteCompostableMaterials },
        SEA_WasteVolunteer: { value: data.SEA_WasteVolunteer },
        SEA_WasteTrashColl: { value: data.SEA_WasteTrashColl },
        SEA_WasteReduction: { value: data.SEA_WasteReduction },
        SEA_IsParkingAvailable: { value: data.SEA_IsParkingAvailable },
        SEA_ParkingOffsite: { value: data.SEA_ParkingOffsite },
        SEA_ParkingOffsiteDesc: { value: data.SEA_ParkingOffsiteDesc },
        SEA_ParkingShuttleOpt: { value: data.SEA_ParkingShuttleOpt },
        SEA_ParkingDesc: { value: data.SEA_ParkingDesc },
        SEA_Restrooms: { value: data.SEA_Restrooms },
        SEA_RestroomInsideMale: { value: data.SEA_RestroomInsideMale },
        SEA_RestroomInsideFemale: { value: data.SEA_RestroomInsideFemale },
        SEA_RestroomInsideHandicap: { value: data.SEA_RestroomInsideHandicap },
        SEA_RestroomOutsideMale: { value: data.SEA_RestroomOutsideMale },
        SEA_RestroomOutsideFemale: { value: data.SEA_RestroomOutsideFemale },
        SEA_RestroomOutsideHandicap: { value: data.SEA_RestroomOutsideHandicap },
        SEA_RestroomHandWashing: { value: data.SEA_RestroomHandWashing },
        SEA_RestroomContracting: { value: data.SEA_RestroomContracting },
        SEA_DIS_Bool: { value: data.SEA_DIS_Bool },
        SEA_DIS_Parking: { value: data.SEA_DIS_Parking },
        SEA_DIS_List: SEA_DIS_List,
        SEA_Signage: { value: data.SEA_Signage },
        SEA_SignageLocDesc: { value: data.SEA_SignageLocDesc },
        SEA_FoodBeverage: { value: data.SEA_FoodBeverage },
        SEA_FoodAlcohol: { value: data.SEA_FoodAlcohol },
        SEA_FoodService: { value: data.SEA_FoodService },
        SEA_FoodVendorNum: { value: data.SEA_FoodVendorNum },
        SEA_Signature: { value: data.SEA_Signature },
        SEA_SubmitterFirst: { value: data.SEA_SubmitterFirst },
        SEA_SubmitterLast: { value: data.SEA_SubmitterLast },
        SEA_SubmitterEmail: { value: data.SEA_SubmitterEmail },
        SEA_SubmitterPosition: { value: data.SEA_SubmitterPosition },
        events: packEvents,
        uploadedFiles: { value: data.uploadedFiles },
        disabled: data.disabled,
        signature: data.signature,
        attest: data.attest,
        specialEventId: data.specialEventId,
      }
    }
  },

  breakupPackage(data) {
    //console.log({ data: data });
    let setupTime = data.SendFields.SEA_SetupTime ? data.SendFields.SEA_SetupTime.selectedDate ? moment(data.SendFields.SEA_SetupTime.selectedDate).toDate() : null : null;
    let eventStartTime = data.SendFields.SEA_EventStartTime ? data.SendFields.SEA_EventStartTime.selectedDate ? moment(data.SendFields.SEA_EventStartTime.selectedDate).toDate() : null : null;
    let eventEndTime = data.SendFields.SEA_EventEndTime ? data.SendFields.SEA_EventEndTime.selectedDate ? moment(data.SendFields.SEA_EventEndTime.selectedDate).toDate() : null : null;
    let breakdownTime = data.SendFields.SEA_BreakdownTime ? data.SendFields.SEA_BreakdownTime.selectedDate ? moment(data.SendFields.SEA_BreakdownTime.selectedDate).toDate() : null : null;
    let events = [];
    if (data.SendFields.events) {
      if (data.SendFields.events.length > 0) {
        events = data.SendFields.events.map(event => {
          let popEvent = {
            id: event.id,
            SEA_SetupTime: event.SEA_SetupTime.selectedDate ? moment(event.SEA_SetupTime.selectedDate).toDate() : null,
            SEA_EventStartTime: event.SEA_EventStartTime.selectedDate ? moment(event.SEA_EventStartTime.selectedDate).toDate() : null,
            SEA_EventEndTime: event.SEA_EventEndTime.selectedDate ? moment(event.SEA_EventEndTime.selectedDate).toDate() : null,
            SEA_BreakdownTime: event.SEA_BreakdownTime.selectedDate ? moment(event.SEA_BreakdownTime.selectedDate).toDate() : null,
          }
          return popEvent;
        });
      }
    }

    let topics = [];
    const topicFromDb = data.SendFields.SEA_Topics;
    if (Object.prototype.hasOwnProperty.call(topicFromDb, 'selectedValue')) {

      //console.log(topicFromDb.selectedValue);
      topics = topicFromDb.selectedValue.split(",");
      //console.log(topics);
    }

    let SEA_DIS_List = [];
    if (data.SendFields.SEA_DIS_List) {
      if (data.SendFields.SEA_DIS_List.length > 0) {
        SEA_DIS_List = data.SendFields.SEA_DIS_List.map(event => {
          let popEvent = {
            id: event.id,
            dis_type: event.dis_type.value,
            dis_StartTime: event.dis_StartTime.selectedDate ? moment(event.dis_StartTime.selectedDate).toDate() : null,
            dis_EndTime: event.dis_EndTime.selectedDate ? moment(event.dis_EndTime.selectedDate).toDate() : null,
            dis_Location: event.dis_Location.value,
            dis_Extent: event.dis_Extent.value,
          }
          return popEvent;
        });
      }
    }
    return {
      id: data.id,
      SEA_Title: data.SendFields.SEA_Title.value ? data.SendFields.SEA_Title.value : '',
      SEA_Location: data.SendFields.SEA_Location.value,
      SEA_CivicAssociation: data.SendFields.SEA_CivicAssociation.selectedValue,
      SEA_Summary: data.SendFields.SEA_Summary.value,
      SEA_Vision: data.SendFields.SEA_Vision.value,
      SEA_PreviouslyHeld: data.SendFields.SEA_PreviouslyHeld.selectedValue,
      SEA_PreviousDate: data.SendFields.SEA_PreviousDate.selectedDate,
      SEA_PreviousLocation: data.SendFields.SEA_PreviousLocation.value,
      SEA_PreviousSponsor: data.SendFields.SEA_PreviousSponsor.value,
      SEA_IsThisaSingle: data.SendFields.SEA_IsThisaSingle.selectedValue,
      SEA_SetupTime: setupTime,
      SEA_EventStartTime: eventStartTime,
      SEA_EventEndTime: eventEndTime,
      SEA_BreakdownTime: breakdownTime,
      SEA_AttendeesMin: data.SendFields.SEA_AttendeesMin.value,
      SEA_AttendeesMax: data.SendFields.SEA_AttendeesMax.value,
      SEA_ManagerNameFirst: data.SendFields.SEA_ManagerNameFirst.value,
      SEA_ManagerNameLast: data.SendFields.SEA_ManagerNameLast.value,
      SEA_ManagerEmail: data.SendFields.SEA_ManagerEmail.value,
      SEA_EventContactPhone: data.SendFields.SEA_EventContactPhone.value,
      SEA_Nonprofit: data.SendFields.SEA_Nonprofit.selectedValue,
      SEA_SponsorNameFirst: data.SendFields.SEA_SponsorNameFirst.value,
      SEA_SponsorNameLast: data.SendFields.SEA_SponsorNameLast ? data.SendFields.SEA_SponsorNameLast.value : null,
      SEA_SponsorEmail: data.SendFields.SEA_SponsorEmail.value,
      SEA_SponsorContactPhone: data.SendFields.SEA_SponsorContactPhone ? data.SendFields.SEA_SponsorContactPhone.value : null,
      SEA_SponsorAddress1: data.SendFields.SEA_SponsorAddress1.value,
      SEA_SponsorAddress2: data.SendFields.SEA_SponsorAddress2.value,
      SEA_SponsorAddressCity: data.SendFields.SEA_SponsorAddressCity.value,
      SEA_SponsorAddressState: data.SendFields.SEA_SponsorAddressState.value,
      SEA_SponsorAddressZIP: data.SendFields.SEA_SponsorAddressZIP.value,
      SEA_PreviousGrossRevenue: data.SendFields.SEA_PreviousGrossRevenue.value,
      SEA_PreviousCost: data.SendFields.SEA_PreviousCost.value,
      SEA_PreviousCharges: data.SendFields.SEA_PreviousCharges.value,
      SEA_EstimatedGrossRevenue: data.SendFields.SEA_EstimatedGrossRevenue.value,
      SEA_EstimatedTotalExpense: data.SendFields.SEA_EstimatedTotalExpense.value,
      SEA_FeeReductionAward: data.SendFields.SEA_FeeReductionAward.selectedValue === 1 ? 'Yes' : 'No',
      SEA_PSS_Extreme: data.SendFields.SEA_PSS_Extreme.selectedValue,
      SEA_PSS_StreetClosures: data.SendFields.SEA_PSS_StreetClosures.selectedValue,
      SEA_PSS_ClosureArea: data.SendFields.SEA_PSS_ClosureArea.selectedValue,
      SEA_PSS_ClosureAreaDesc: data.SendFields.SEA_PSS_ClosureAreaDesc.value,
      SEA_PSS_Checkpoints: data.SendFields.SEA_PSS_Checkpoints.selectedValue,
      SEA_PSS_Hazardous: data.SendFields.SEA_PSS_Hazardous.selectedValue,
      SEA_PSS_HazardousPurpose: data.SendFields.SEA_PSS_HazardousPurpose.value,
      SEA_PSS_KnownThreats: data.SendFields.SEA_PSS_KnownThreats.selectedValue,
      SEA_PSS_SecurityStaff: data.SendFields.SEA_PSS_SecurityStaff.value,
      SEA_PSS_Sound: data.SendFields.SEA_PSS_Sound.selectedValue,
      SEA_PSS_SoundDesc: data.SendFields.SEA_PSS_SoundDesc.value,
      SEA_PSS_Overnight: data.SendFields.SEA_PSS_Overnight.selectedValue,
      SEA_PSS_Assemblage: data.SendFields.SEA_PSS_Assemblage.selectedValue,
      SEA_Certificate_ANIRequired_1: data.SendFields.SEA_Certificate_ANIRequired_1.value === 1 ? 'Yes' : 'No',
      SEA_Animals: data.SendFields.SEA_Animals.selectedValue,
      SEA_Certificate_INSRequired_2: data.SendFields.SEA_Certificate_INSRequired_2.value === 1 ? 'Yes' : 'No',
      SEA_Insurance: data.SendFields.SEA_Insurance.selectedValue,
      SEA_InsuranceName: data.SendFields.SEA_InsuranceName.value,
      SEA_License: data.SendFields.SEA_License.value === 1 ? 'Yes' : 'No',
      SEA_Public: data.SendFields.SEA_Public.value,
      SEA_Publicized: data.SendFields.SEA_Publicized.value === 1 ? 'Yes' : 'No',
      SEA_CalendarDescription: data.SendFields.SEA_CalendarDescription.value,
      SEA_FreeOrPaid: data.SendFields.SEA_FreeOrPaid.selectedValue,
      SEA_EventFee: data.SendFields.SEA_EventFee.value,
      SEA_Topics: topics,
      SEA_IsThisaFamilyFriendly: data.SendFields.SEA_IsThisaFamilyFriendly.selectedValue === 1 ? 'Yes' : 'No',
      SEA_MinimumAge: data.SendFields.SEA_MinimumAge.value,
      SEA_MaximumAge: data.SendFields.SEA_MaximumAge.value,
      SEA_PublicContactNameFirst: data.SendFields.SEA_PublicContactNameFirst.value,
      SEA_PublicContactNameLast: data.SendFields.SEA_PublicContactNameLast.value,
      SEA_PublicContactEmail: data.SendFields.SEA_PublicContactEmail.value,
      SEA_PublicContactPhone: data.SendFields.SEA_PublicContactPhone.value,
      SEA_Website: data.SendFields.SEA_Website.value,
      SEA_MobileStage: data.SendFields.SEA_MobileStage.value,
      SEA_PlanUpload: data.SendFields.SEA_PlanUpload.value,
      SEA_PlanURL: data.SendFields.SEA_PlanURL.value,
      SEA_Tents: data.SendFields.SEA_Tents.value,
      SEA_Permit_OCCRequired_5: data.SendFields.SEA_Permit_OCCRequired_5.value, //  === 1 ? 'Yes' : 'No'
      SEA_Permit_BUILDRequired_6: data.SendFields.SEA_Permit_BUILDRequired_6.value, //  === 1 ? 'Yes' : 'No'
      SEA_AmusementDevices: data.SendFields.SEA_AmusementDevices.value,
      SEA_AmusementDeviceDesc: data.SendFields.SEA_AmusementDeviceDesc.value,
      SEA_Permit_ElectricalRequired_11: data.SendFields.SEA_Permit_ElectricalRequired_11.value, // === 1 ? 'Yes' : 'No'
      SEA_Permit_ElectricalNotes_11: data.SendFields.SEA_Permit_ElectricalNotes_11.value,
      SEA_WaterStation: data.SendFields.SEA_WaterStation.value,
      SEA_StreetSweeping: data.SendFields.SEA_StreetSweeping.selectedValue,
      SEA_WasteDisposalPlan: data.SendFields.SEA_WasteDisposalPlan.value,
      SEA_WasteTypeQual: data.SendFields.SEA_WasteTypeQual.value,
      SEA_WasteCompostableMaterials: data.SendFields.SEA_WasteCompostableMaterials.value,
      SEA_WasteVolunteer: data.SendFields.SEA_WasteVolunteer.value,
      SEA_WasteTrashColl: data.SendFields.SEA_WasteTrashColl.value,
      SEA_WasteReduction: data.SendFields.SEA_WasteReduction.value,
      SEA_IsParkingAvailable: data.SendFields.SEA_IsParkingAvailable.value,
      SEA_ParkingOffsite: data.SendFields.SEA_ParkingOffsite.value,
      SEA_ParkingOffsiteDesc: data.SendFields.SEA_ParkingOffsiteDesc.value,
      SEA_ParkingShuttleOpt: data.SendFields.SEA_ParkingShuttleOpt.value,
      SEA_ParkingDesc: data.SendFields.SEA_ParkingDesc.value,
      SEA_Restrooms: data.SendFields.SEA_Restrooms.value,
      SEA_RestroomInsideMale: data.SendFields.SEA_RestroomInsideMale.value,
      SEA_RestroomInsideFemale: data.SendFields.SEA_RestroomInsideFemale.value,
      SEA_RestroomInsideHandicap: data.SendFields.SEA_RestroomInsideHandicap.value,
      SEA_RestroomOutsideMale: data.SendFields.SEA_RestroomOutsideMale.value,
      SEA_RestroomOutsideFemale: data.SendFields.SEA_RestroomOutsideFemale.value,
      SEA_RestroomOutsideHandicap: data.SendFields.SEA_RestroomOutsideHandicap.value,
      SEA_RestroomHandWashing: data.SendFields.SEA_RestroomHandWashing.value,
      SEA_RestroomContracting: data.SendFields.SEA_RestroomContracting.value,
      SEA_DIS_Bool: data.SendFields.SEA_DIS_Bool.value,
      SEA_DIS_Parking: data.SendFields.SEA_DIS_Parking.value,
      SEA_DIS_List: SEA_DIS_List,
      SEA_Signage: data.SendFields.SEA_Signage.value,
      SEA_SignageLocDesc: data.SendFields.SEA_SignageLocDesc.value,
      SEA_FoodBeverage: data.SendFields.SEA_FoodBeverage.value,
      SEA_FoodAlcohol: data.SendFields.SEA_FoodAlcohol.value,
      SEA_FoodService: data.SendFields.SEA_FoodService.value,
      SEA_FoodVendorNum: data.SendFields.SEA_FoodVendorNum.value,
      SEA_Signature: data.SendFields.SEA_Signature.value,
      SEA_SubmitterFirst: data.SendFields.SEA_SubmitterFirst.value,
      SEA_SubmitterLast: data.SendFields.SEA_SubmitterLast.value,
      SEA_SubmitterEmail: data.SendFields.SEA_SubmitterEmail.value,
      SEA_SubmitterPosition: data.SendFields.SEA_SubmitterPosition.value,
      events: events,
      uploadedFiles: data.SendFields.uploadedFiles ? data.SendFields.uploadedFiles.value : [],
      disabled: data.SendFields.disabled != undefined ? data.SendFields.disabled : false,
      signature: data.SendFields.signature ? data.SendFields.signature : undefined,
      attest: data.SendFields.attest ? data.SendFields.attest : null,
      specialEventId: data.SendFields.specialEventId ? data.SendFields.specialEventId : null,
    }
  },

  get(params) {
    return fetch(saveDraftHttpFunction + "&docId=" + params.docId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },

  getId() {
    return fetch(saveDraftHttpFunction + "&getId=true", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },

  save(data, docId, submitApp) {
    let sendFields = [];
    let thisDocSaveUrl = saveDraftHttpFunction;
    if (docId) {
      //console.log('docId', docId, 'already exists');
      thisDocSaveUrl = thisDocSaveUrl + "&docId=" + docId;
    }
    if (submitApp) {
      thisDocSaveUrl = thisDocSaveUrl + "&submitApp=true"
    }

    let pack = this.createPackage(data);
    if (docId) {
      pack.SendFields.id = docId;
    }
    sendFields.push(pack);

    //sendFields.forEach(pack => {
    return fetch(thisDocSaveUrl, {
      method: 'POST',
      body: JSON.stringify(sendFields[0]), //pack
      headers: {
        'Content-Type': 'application/json',
        //'Access-Control-Allow-Origin': '*'
      }
    });
    //})
  },

  getTopics() {
    return fetch("https://datahub.arlingtonva.us/api/event/topic", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    })
  },

  async upload(fileContent, fileName, docId) {
    const containerClient = blobServiceClient.getContainerClient(containerName);
    //console.log(fileContent);
    const contentAwait = await fileContent.arrayBuffer();
    const content = await contentAwait;
    //console.log(content);
    const blobName = docId + "_" + fileName;
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    const uploadBlobResponse = await blockBlobClient.upload(content, fileContent.size);
    //console.log(`Upload block blob ${blobName} successfully`, uploadBlobResponse.requestId);
    const returnResponse = {
      fileName: fileName,
      blobResponse: uploadBlobResponse,
    }
    return returnResponse;
  },

  async uploadSignature(fileContent, fileName, docId) {
    const containerClient = blobServiceClient.getContainerClient(containerName);
    //data:image/png;base64,
    fileContent = fileContent.substring(22)
    //console.log({ fileContent: fileContent });
    const binary_string = window.atob(fileContent);
    //console.log({ binary_string: binary_string });
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    let content = bytes.buffer;
    //console.log({ content: content });
    const blobName = docId + "_" + fileName;
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    const uploadBlobResponse = await blockBlobClient.upload(content, bytes.buffer.byteLength);
    //console.log(`Upload block blob ${blobName} successfully`);
    const returnResponse = {
      fileName: fileName,
      blobResponse: uploadBlobResponse,
    }
    return returnResponse;
  }

}



export default service;